import React, { FC, PropsWithChildren } from 'react';
import { Element } from 'react-scroll';
import cx from 'classnames';
import './Panel.scss';

interface PanelProps {
  className?: string;
  name?: string;
}

const Panel: FC<PropsWithChildren<PanelProps>> = (props) => {
  const { className, name, children } = props;

  const panelElement = <div className={cx('panel', className)}>{children}</div>;

  if (name) {
    return <Element name={name}>{panelElement}</Element>;
  }

  return panelElement;
};

export default Panel;
